import { TEMPLATES_ROUTES } from '../../constants/_routes'
import { formatRoute } from 'react-router-named-routes'
import templatesTypes from '../../constants/templatesTypes'
import { axios } from '../../services'

// 1 unpublish
const unpublish_template_request = () => {
  return {
    type: templatesTypes.publish.request
  }
}

const unpublish_template_success = (response) => {
  return {
    type: templatesTypes.publish.success,
    payload: response.data
  }
}

const unpublish_single_template_success = (response) => {
  return {
    type: templatesTypes.publish.single,
    payload: response.data
  }
}

const unpublish_template_failure = (messages) => {
  return {
    type: templatesTypes.publish.failure,
    payload: messages
  }
}

const unpublish_template = (template_id, index=true, page=1, per_page=10, filters={}, sort="", order="") => {
  return function(dispatch) {
    // Before Request
    dispatch( unpublish_template_request() )
    const reqParams = index ? {
      index: index,
      page: page,
      per_page: per_page,
      sort: sort,
      order: order,
      filters: filters
    } : {index: index}
    // Request
    axios.post(
      formatRoute(TEMPLATES_ROUTES.unpublish, {id: template_id}),
      reqParams
    ).then( response => {
      window.showSnackbar('success', 'The template status has changed to: Draft.')
      if ( index ) {
        dispatch( unpublish_template_success(response) )

      } else {
        dispatch( unpublish_single_template_success(response) )

      }
    }).catch( error=> {
      // failure
      let errors
      if (error.response && error.response.data && error.response.data.errors) {
        errors = error.response.data.errors
      } else {
        errors = ["Error unpublishing template"]
      }
      dispatch( unpublish_template_failure( errors ) )
    })
  }
}

export {unpublish_template}



// WEBPACK FOOTER //
// ./src/js/actions/templates/unpublish.js